import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
// import { GaugeChartModule } from 'angular-gauge-chart';
import { NgChartsModule } from 'ng2-charts';
// import { NgApexchartsModule } from "ng-apexcharts";
import { ListGadget } from './list/list.gadget';
import { ListTextGadget } from './list-text/list-text.gadget';
import { CardGadget } from './card/card.gadget';
// import { GaugeGadget } from './gauge/gauge.gadget';
import { BarGadget } from './bar/bar.gadget';
import { Bar2Gadget } from './bar2/bar2.gadget';
import { PieGadget } from './pie/pie.gadget';
import { GridGadget } from './grid/grid.gadget';
import { TrendBarGadget } from "./trend-bar/trend-bar.gadget";
import { ProgressGadget } from "./progress/progress.gadget";
import { FeedbackStatisticsGadget } from "./feedback-statistics/feedback-statistics.gadget";
import { SelectGadget } from "./select/select.gadget";
// import { HeatmapGadget } from './heatmap/heatmap.gadget';
import { BarChartGadget } from './bar-chart/bar-chart.gadget';
import { MultipleBarsGadget } from './multiple-bars/multiple-bars.gadget';
import { MultipleBarsRestApiGadget } from "./multiple-bars-rest-api/multiple-bars.gadget";
import { DoughnutChartGadget } from './doughnut-charts/doughnut-charts.gadget';
import { ListByFiltersGadget } from './list-by-filters/list-by-filters.gadget';
import { CheckToPrintGadget } from "./check-to-print/check-to-print.gadget";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatSelectModule } from '@angular/material/select';
import { ContentloaderModule } from '@signature-it/ngx-generic/components/contentloader';
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SafePipeModule} from "@signature-it/ngx-generic/pipes";

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FormsModule,
        // GaugeChartModule,
        NgChartsModule,
        RouterModule,
        NgxDatatableModule,
        ContentloaderModule,
        NgbModule,
        MatSelectModule,
        // NgApexchartsModule,
        TooltipModule,
        MatCheckboxModule,
       SafePipeModule
    ],
    declarations: [
        ListGadget,
        ListTextGadget,
        CardGadget,
        // GaugeGadget,
        BarGadget,
        Bar2Gadget,
        PieGadget,
        GridGadget,
        TrendBarGadget,
        ProgressGadget,
        MultipleBarsGadget,
        FeedbackStatisticsGadget,
        SelectGadget,
        BarChartGadget,
        // HeatmapGadget,
        DoughnutChartGadget,
        MultipleBarsRestApiGadget,
        ListByFiltersGadget,
        CheckToPrintGadget
    ],
    exports: [
        ListGadget,
        ListTextGadget,
        CardGadget,
        // GaugeGadget,
        BarGadget,
        Bar2Gadget,
        PieGadget,
        GridGadget,
        TrendBarGadget,
        ProgressGadget,
        MultipleBarsGadget,
        FeedbackStatisticsGadget,
        SelectGadget,
        BarChartGadget,
        // HeatmapGadget,
        DoughnutChartGadget,
        MultipleBarsRestApiGadget,
        ListByFiltersGadget,
        CheckToPrintGadget,
    ]
})
export class GadgetsModuleGeneric {}
